import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { useCustomData } from '../../pages/context/serviceCustomDataProvider';

interface ServiceHomePart4Props {
  handleViewChange: (newView: string, data?: any) => void;
  data?: any;
  onOpenModal?: (type: 'basic' | 'premium') => void;
  onOpenNote?: (type: 'basic' | 'premium') => void;
}

interface eInteriorData {
  advantage: string;
  describe: string;  // HTML 字符串
}

const ServiceHomePart4: React.FC<ServiceHomePart4Props> = ({
  handleViewChange,
  data,
  onOpenModal,
  onOpenNote,
}) => {
  const themeColor = useSelector((state: RootState) => state.themeColor.value);
  const { customData } = useCustomData();
  const [foundationList, setFoundationList] = useState<eInteriorData[]>([
    // 这里先可以留空或者放默认值
  ]);

  useEffect(() => {
    const order = [
      'ServiceAdvantagessOne',
      'ServiceAdvantagessTwo',
      'ServiceAdvantagessThree',
      'ServiceAdvantagessFour',
      'ServiceAdvantagessFive',
    ];

    const customList: eInteriorData[] = [];

    order.forEach(code => {
      const item = customData.find(d => d.code === code);
      if (item && typeof item.value === 'string') {
        // 用 ～ 分割成 advantage 和 describeRaw
        const [advantageRaw, describeRaw] = item.value.split('～');
        const advantage = advantageRaw?.trim() ?? '';

        // 用 ｜ 分割成多个段落
        const describeParts = describeRaw ? describeRaw.split('｜') : [];
        // 每段加 <p> 标签，并合成字符串
        const describe = describeParts.map(part => `<p>${part.trim()}</p>`).join('');

        customList.push({ advantage, describe });
      }
    });

    setFoundationList(customList);
  }, [customData]);

  const goBack = () => {
    handleViewChange('service-index');
  };

  return (
    <div className="service-part4-item">
      {foundationList.map((item, index) => (
        <div className="part4-inner-item" key={index}>
          <p className="part4-inner-item-first" style={{ color: themeColor }}>
            {item.advantage}
          </p>
          <div className="part4-line"></div>
          <div
            className="part4-inner-item-second"
            dangerouslySetInnerHTML={{ __html: item.describe }}
          ></div>
        </div>
      ))}
    </div>
  );
};

export default ServiceHomePart4;
